module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"deleteTeamTitle":"Supprimer l\u0027équipe","deleteTeamText":"Voulez-vous supprimer cette équipe ?","deleteTeamBtnNo":"Ne pas supprimer","deleteTeamBtnYes":"Supprimer","deleteBtnTitle":"Supprimer"},"en":{"deleteTeamTitle":"Delete team","deleteTeamText":"Do you want to delete this team?","deleteTeamBtnNo":"Do not delete","deleteTeamBtnYes":"Delete","deleteBtnTitle":"Delete"}}')
  delete Component.options._Ctor
}
